"use client";

import { useSyncExternalStore } from "react";
import { useColorMode } from "@/components/app/color-mode-provider";
import type { ColorMode } from "@/lib/theme/color-mode";

function subscribeSystemDark(onStoreChange: () => void): () => void {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  mq.addEventListener("change", onStoreChange);
  return () => mq.removeEventListener("change", onStoreChange);
}

function getSystemDarkSnapshot(): boolean {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function resolveIsDarkMode(
  mode: ColorMode,
  systemPrefersDark: boolean,
): boolean {
  return mode === "dark" || (mode === "system" && systemPrefersDark);
}

/** Тёмная тема с учётом mode=system — не зависит от data-theme на html. */
export function useResolvedDarkMode(): boolean {
  const { mode } = useColorMode();
  const systemDark = useSyncExternalStore(
    subscribeSystemDark,
    getSystemDarkSnapshot,
    () => false,
  );

  return resolveIsDarkMode(mode, systemDark);
}
